import API from "Services/Api";
import { createFilterParams } from "Utils/searchFilters";
import { PreOrderDetail } from "./Partners/PreBudgets";

export type PreOrderUnitFilters = {
  page: number;
  per_page?: string;
  start_date?: string;
  end_date?: string;
  /** Unidade selecionada (id) */
  unit_id?: string;
  status_id?: number[];
  state?: string;
  have_health_insurance?: boolean;
  name?: string;
  email?: string;
  phone?: string;
  document?: string;
};

export type PreOrderUnitListItem = {
  id: number;
  acuity_id: number | null;
  appointment_at: string | null;
  full_name: string;
  email: string;
  document: string;
  created_at: string;
  locked_by: number | null;
  locked_at: string | null;
  budget_id: number | null;
  order_id: number | null;
  person_id: number | null;
  ddi: string;
  ddd: string;
  phone: string;
  birth_date: string;
  weight: number | null;
  height: number | null;
  gender: string;
  mothers_full_name: string | null;
  symptoms_start_date: string | null;
  have_health_insurance: boolean | null;
  health_insurance_card_number: string | null;
  observation: string | null;
  crm: string | null;
  doctor: string | null;
  unit_id: number | null;
  health_insurance: string | null;
  products: {
    amount: number;
    id: number;
    price: string;
    product: string;
    sku: string;
  };
  client: {
    id: number;
    name: string;
    pre_flow: boolean;
  };
  status: string;
  files: any[];
};
export type PreOrderDetailsUnit = Omit<PreOrderDetail, "files"> & {
  health_insurance_card_number: string;
  have_health_insurance: string;
  health_files: { file_path: string }[];
  order_files: { file_path: string }[];
};
export type Unit = {
  id: number;
  motion_code: number;
  name: string;
};

export type PreOrderUnitResponse = {
  data: PreOrderUnitListItem[];
  total: number;
  page: number;
  per_page: number;
  last_page: number;
  current_page: number;
};

export const getPreOrderUnit = async (
  filters: PreOrderUnitFilters
): Promise<PreOrderUnitResponse | undefined> => {
  try {
    const { have_health_insurance, ...rest } = filters;

    const params = createFilterParams(
      rest as Record<string, string | number | number[] | undefined>
    );

    if (have_health_insurance !== undefined) {
      params.have_health_insurance = have_health_insurance;
    }

    const response = await API.get(`/clients/units/pre-orders`, { params });

    return response.data;
  } catch (error: any) {
    console.log({ error });
    return undefined;
  }
};

export const getPreOrderUnitDetails = async (id: number) => {
  try {
    const response = await API.get(`/clients/units/pre-orders/${id}`);

    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getUnitsByUser = async () => {
  try {
    const response = await API.get("/clients/units/user");
    return response.data;
  } catch (error) {
    console.log({ error });
  }
};
